import { styled } from '@mui/material/styles';

// Shared green header gradient/shadow used by the follow-up / attended / hub pop-up headers.
export const POPUP_HEADER_GRADIENT = 'linear-gradient(135deg, #00A76F 0%, #007867 100%)';
export const POPUP_HEADER_SHADOW = '0 2px 12px rgba(0, 167, 111, 0.2)';
// Shared header padding (horizontal / vertical) — used by commonDialogHeaderStyle and the lead-detail Back bar.
export const POPUP_HEADER_PX = 3;
export const POPUP_HEADER_PY = 2;
export const commonDialogHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    px: POPUP_HEADER_PX,
    rowGap: 1.5,
    flexDirection: { sm: 'row' },
    position: 'fixed !important',
    top: 0,
    textAlign: 'center',
    pt: POPUP_HEADER_PY,
    pb: POPUP_HEADER_PY,
    bgcolor: 'transparent',
    background: POPUP_HEADER_GRADIENT,
    boxShadow: POPUP_HEADER_SHADOW,
};
export const onBoardDialogHeader = {
    position: 'fixed !important',
    bgcolor: 'transparent',
    background: POPUP_HEADER_GRADIENT,
    boxShadow: POPUP_HEADER_SHADOW,
    top: 0,
    textAlign: 'center',
    pt: 2,
    pb: 2
};
export const reminderDialogStyle =  type => ({
    zIndex: type === 'onboarad' ? 1117 : 1200,
    margin: { xs: '0 -16px', sm: 0 },
    pt: { xs: 15, sm: 10 },
    '.MuiDialog-paperFullScreen': {
        bgcolor: '#F9FAFB',
    }
});
export const reminderTitleStyle = {
    display: 'block',
    fontSize: '18px !important',
    lineHeight: '24px',
    fontWeight: 600,
    color: '#fff'
};
export const cancelBoxStyle = {
    display: 'flex',
    columnGap: 2,
    justifyContent: 'center'
};
export const reminderStackStyle = {
    display: 'inline-block',
    padding: {
        md: '40px 30px 150px',
        xs: '40px 10px 150px 5px'
    }
};
export const appointmentTreatmentStyle = {
    width: '100%',
    maxWidth: { md: 'calc(70% - 20px)' },
    mb: {
        sm: 0,
        xs: 0
    }
};

// openAttenedPopUp
export const attendedStackStyle = {
    display: 'inline-block',
    padding: {
        md: '70px 30px 150px',
        xs: '70px 10px 150px 5px'
    }
};

// openPayment
export const leadFooterButtonsStyle = {
    mt: 3,
    display: 'flex',
    justifyContent: 'center',
    pr: { xs: 4 },
    pl: { xs: 4 },
    '@media(max-width: 900px)': {
        mt: '20px'
    }
};

export const finishButtonStyle = type => (
    type === 'createLead' || type === 'followup' ? {
        px: { xs: 3.5, sm: 8 }
    } : {
        px: { xs: 3.5, sm: 8 },
        py: 0.75
    }
);

// unattended

export const PhoneIconButton = styled('div')(() => ({
    backgroundColor: 'rgba(0, 171, 85, 0.12)',
    borderRadius: 14,
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 16,
    boxShadow: '0 2px 8px rgba(0, 171, 85, 0.15)',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
        transform: 'scale(1.05)',
        boxShadow: '0 4px 16px rgba(0, 171, 85, 0.25)',
    }
}));

export const footerBoxStyle = {
    width: '100%',
    pb: 4,
    pt: 1.5,
    position: 'fixed',
    left: 0,
    bottom: 0,
    bgcolor: 'background.paper',
    zIndex: 99,
    borderTop: '1px solid',
    borderColor: 'divider',
    boxShadow: '0 -2px 12px rgba(145, 158, 171, 0.08)',
    '@media(max-width: 900px)': {
        pb: '20px'
    }
};

// reschedule
export const btnStyle = {
    py: 0.75,
    px: {
        xs: 3.5,
        sm: 8
    }
};